<template>
  <div class="actiontdiv">
    <feather-icon
      v-if="item.is_archived"
      v-b-tooltip.hover.lefttop.v-primary
      title="Desarquivar projeto"
      icon="RefreshCwIcon"
      size="15"
      style="cursor: pointer;"
      @click="openUnDeleteModal(item)"
    />

    <feather-icon
      v-if="!item.is_archived"
      v-b-tooltip.hover.lefttop.v-primary
      title="Arquivar projeto"
      icon="FolderMinusIcon"
      size="15"
       style="cursor: pointer;"
      @click="openDeleteModal(item)"
    />
    <feather-icon
      v-if="!item.is_archived"
      v-b-tooltip.hover.lefttop.v-primary
      title="Excluir projeto"
      icon="TrashIcon"
      size="15"
       style="cursor: pointer;"
      @click="openDeleteProjectModal(item)"
    />
    <feather-icon
      v-b-tooltip.hover.lefttop.v-primary
      title="Dashboard"
      icon="BarChartIcon"
      size="15"
       style="cursor: pointer;"
      @click="$router.push(`/projetos/dashboard/${item.id}`)"
    />
    <feather-icon
      v-b-tooltip.hover.lefttop.v-primary
      title="Editar projeto"
      icon="EditIcon"
      size="15"
       style="cursor: pointer;"
      @click="$router.push(`/editar-projeto/${item.id}`)"
    />
    <feather-icon
      v-b-tooltip.hover.lefttop.v-primary
      title="Tarefas do projeto"
      icon="BookOpenIcon"
      size="15"
       style="cursor: pointer;"
      @click="$router.push(`/tarefas-projeto/${item.id}`)"
    />
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
// import { RefreshCwIcon } from 'vue-feather-icons';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    item: { type: Object, default: () => {} },
  },
  methods: {
    openDeleteModal(item) {
      this.$emit('openDeleteModal', item);
    },

    openDeleteProjectModal(item) {
      this.$emit('openDeleteProjectModal', item);
    },

    openUnDeleteModal(item) {
      this.$emit('openUnDeleteModal', item);
    },
  },
};
</script>

<style>
.actiontdiv {
  display: flex;
  gap: 5px;
}
</style>
import { TrashIcon } from 'vue-feather-icons';, RefreshCwIcon
